/* THIS IS A GENERATED FILE, DO NOT EDIT */
// import utils
import { z } from "zod";
import iconCollection from "./icon-collection.js";
export const iconValidator = z.enum(iconCollection);
export default iconValidator;
